export const MOBILE_SIDEBAR_OPEN_EVENT = 'mobile-sidebar:open';

/** Open the app-shell mobile navigation drawer from any React island. */
export function openMobileSidebar() {
  document.dispatchEvent(new CustomEvent(MOBILE_SIDEBAR_OPEN_EVENT));
}